import React from 'react';
import { string } from 'prop-types';
import { Snackbar as StellarSnackbar } from '@lavu-pos/stellar';
import { useSnackbar, SNACKBAR_TYPES } from '../context/SnackbarsContext';

const getStatus = state => {
	const { success, error, warning, info } = state;

	return success.active || error.active || warning.active || info.active;
};

const getType = state => {
	const { success, error, warning, info } = state;
	const { SUCCESS, ERROR, WARNING, INFO } = SNACKBAR_TYPES;

	if (success.active) {
		return SUCCESS;
	} else if (error.active) {
		return ERROR;
	} else if (warning.active) {
		return WARNING;
	} else if (info.active) {
		return INFO;
	}

	return null;
};

const getMessage = state => {
	const { success, error, warning, info } = state;

	return state.prevActiveMessage !== ''
		? state.prevActiveMessage
		: success.message || error.message || warning.message || info.message;
};

const getVariant = state => {
	return getType({ ...state }) !== null
		? getType({ ...state })
		: state.prevActiveType;
};

const Snackbar = props => {
	const { elementId, ...otherProps } = props;
	const { state, updater } = useSnackbar();

	return (
		<StellarSnackbar
			open={getStatus({ ...state })}
			handleClose={() => updater(getType({ ...state }), '', { active: false })}
			message={getMessage({ ...state })}
			variant={getVariant({ ...state })}
			action={state.action}
			elementId={elementId}
			{...otherProps}
		/>
	);
};

Snackbar.propTypes = {
	elementId: string,
};

export default Snackbar;
